const MENU_PERMISSION_KEY = "portalMenuPermissions"

export function setMenuPermissions(menus) {
  try {
    localStorage.setItem(MENU_PERMISSION_KEY, JSON.stringify(menus || []))
  } catch (e) {
    /* ignore */
  }
}

export function clearMenuPermissions() {
  localStorage.removeItem(MENU_PERMISSION_KEY)
}

export function getMenuPermissions() {
  try {
    const raw = localStorage.getItem(MENU_PERMISSION_KEY)
    return raw ? JSON.parse(raw) : []
  } catch (e) {
    return []
  }
}

/** 按权限标识判断功能权限；需要修改权限时同时要求查看和修改均已开启。 */
export function hasMenuPermission(permissionCode, requireEdit = false) {
  if (!permissionCode) return false
  const menu = getMenuPermissions().find(item => item && item.permissionCode === permissionCode)
  if (!menu || Number(menu.effectiveCanView) !== 1) return false
  return !requireEdit || Number(menu.effectiveCanEdit) === 1
}

/** 功能/按钮权限使用独立的 effectiveCanUse 字段。 */
export function hasFunctionPermission(permissionCode) {
  if (!permissionCode) return false
  const menu = getMenuPermissions().find(item => item && item.permissionCode === permissionCode)
  return !!menu && Number(menu.effectiveCanUse) === 1
}

/** 仅用于展示：读取后端已过滤的菜单列表 */
export function getMenusByParent(parentMenuId) {
  return getMenuPermissions()
    .filter(item => item && item.parentMenuId === parentMenuId)
    .sort((a, b) => Number(a.sortNo || 0) - Number(b.sortNo || 0))
}

/** 仅用于展示：门户首页系统入口是否可见（数据来自 /api/portal/my/menus） */
export function hasMenuForRoute(routePath) {
  if (!routePath) return false
  return getMenuPermissions().some(item => {
    const path = item && item.routePath
    if (!path) return false
    return path === routePath || path.startsWith(routePath + "/")
  })
}

/** 仅用于展示：当前路由是否允许编辑（读取后端返回的 effectiveCanEdit） */
export function isRouteEditable(routePath) {
  if (!routePath) return false
  const menus = getMenuPermissions().filter(item => item && item.routePath)
  const exact = menus.find(item => item.routePath === routePath)
  if (exact) return Number(exact.effectiveCanEdit) === 1
  const matched = menus
    .filter(item => routePath.startsWith(item.routePath + "/"))
    .sort((a, b) => String(b.routePath).length - String(a.routePath).length)[0]
  return !!matched && Number(matched.effectiveCanEdit) === 1
}
